const state = {
  orderProducts:{}
}

export default state
